import React from 'react'
import classes from './Footer.module.css'
const Footer = () => {
    return (
        <div className={classes.footer}>
            <h4>-Created By Using REACT</h4>
        </div>
    )
}

export default Footer
